"use client"

import { useEffect, useRef } from "react"
import { useServerInsertedHTML } from "next/navigation"

interface JsonLdScriptProps {
  id: string
  data: unknown
}

export function JsonLdScript({ id, data }: JsonLdScriptProps) {
  const json = JSON.stringify(data).replace(/</g, "\\u003c")
  const insertedOnServer = useRef(false)

  useServerInsertedHTML(() => {
    if (insertedOnServer.current) return null
    insertedOnServer.current = true

    return (
      <script
        id={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: json }}
      />
    )
  })

  useEffect(() => {
    const existing = document.getElementById(id)
    if (existing) {
      existing.textContent = json
      return () => {
        if (existing.parentNode) {
          existing.remove()
        }
      }
    }

    const script = document.createElement("script")
    script.id = id
    script.type = "application/ld+json"
    script.textContent = json
    document.head.appendChild(script)

    return () => {
      if (script.parentNode) {
        script.remove()
      }
    }
  }, [id, json])

  return null
}
